var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOferta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15743_42999)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 14.25C6.75 14.6642 6.41421 15 6 15H5.75C4.23122 15 3 13.7688 3 12.25V3C3 2.72386 2.77614 2.5 2.5 2.5C2.08579 2.5 1.75 2.16421 1.75 1.75C1.75 1.33579 2.08579 1 2.5 1H11C12.1046 1 13 1.89543 13 3V11.25C13 11.6642 12.6642 12 12.25 12C11.8358 12 11.5 11.6642 11.5 11.25V3C11.5 2.72386 11.2761 2.5 11 2.5H4.43699C4.47812 2.65981 4.5 2.82735 4.5 3V12.25C4.5 12.9403 5.05964 13.5 5.75 13.5H6C6.41421 13.5 6.75 13.8358 6.75 14.25Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4.74999C6 4.33578 6.33579 3.99999 6.75 3.99999H9.25C9.66421 3.99999 10 4.33578 10 4.74999C10 5.16421 9.66421 5.49999 9.25 5.49999H6.75C6.33579 5.49999 6 5.16421 6 4.74999Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 7.74999C6 7.33578 6.33579 6.99999 6.75 6.99999H9.25C9.66421 6.99999 10 7.33578 10 7.74999C10 8.16421 9.66421 8.49999 9.25 8.49999H6.75C6.33579 8.49999 6 8.16421 6 7.74999Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 2.99999C0.5 1.89542 1.39543 1 2.5 1C3.60457 1 4.5 1.89543 4.5 3V6.74999C4.5 7.16421 4.16421 7.49999 3.75 7.49999H1.25C0.835786 7.49999 0.5 7.16421 0.5 6.74999V2.99999ZM2.5 2.5C2.22386 2.5 2 2.72385 2 2.99999V5.99999H3V3C3 2.72386 2.77614 2.5 2.5 2.5Z",
    fill: "#71869D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 11.25C7 10.8358 7.33579 10.5 7.75 10.5H15C15.4142 10.5 15.75 10.8358 15.75 11.25V12.75C15.75 13.9926 14.7426 15 13.5 15H5.75C5.33579 15 5 14.6642 5 14.25C5 13.8358 5.33579 13.5 5.75 13.5C6.44036 13.5 7 12.9403 7 12.25V11.25ZM8.20015 13.5H13.5C13.9142 13.5 14.25 13.1642 14.25 12.75V12H8.5V12.25C8.5 12.7001 8.39186 13.125 8.20015 13.5Z",
    fill: "#71869D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15743_42999"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOferta);
export default __webpack_public_path__ + "static/media/iconOferta.48d415f884d402084d135efd99a025ff.svg";
export { ForwardRef as ReactComponent };